import Flux from 'lib/flux';
import CurrencyConstants from 'constants/currency';

const SessionStore = Flux.createStore({
  name: 'session',

  getInitialState() {
    return {
      currency: 'USD',
      csrf: this._getCSRFToken(),
      location: {
        country_code: '',
      },
      i18n: 'en-US',
      uuid: '',
    };
  },

  _getCSRFToken() {
    const csrf = {};
    csrf.key = document
      .querySelector('meta[name="csrf-param"]')
      .getAttribute('content');
    csrf.value = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute('content');
    return csrf;
  },

  _getCSRFTokenObject() {
    const csrf = this._getCSRFToken();
    const csrfObject = {};
    csrfObject[csrf.key] = csrf.value;
    return csrfObject;
  },

  getLocationCountryCode() {
    return this.state && this.state.getIn(['location', 'country_code']);
  },

  actions: [
    [
      CurrencyConstants.CURRENCY_UPDATED,
      function (currency) {
        this.state = this.state.set('currency', currency);
      },
    ],
  ],
});

export default SessionStore;
